function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Feather-(Neutral)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Versicherte-Bearbeiten-Popup",
  transform: "translate(-1035.000000, -271.000000)",
  stroke: "#263238",
  className: "toggle",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15",
  transform: "translate(360.000000, 236.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "x-circle",
  transform: "translate(664.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "x-icon",
  transform: "translate(12.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,0 L0,8",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L8,8",
  id: "Path"
}))))));

var SvgXDark = function SvgXDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x-dark.74da36a1.svg";
export { ForwardRef as ReactComponent };